import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';
import BackButton from '../components/BackButton';
import { useEffect } from 'react';

export default function LegalNotice() {
  const { theme } = useTheme();
  const { font } = useFont();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: font.family }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <BackButton />
        </div>

        <div className="bg-white rounded-xl shadow-sm p-8">
          <h1 className={`text-3xl font-bold text-${theme.text} mb-8`}>
            Mentions Légales
          </h1>
          <div className="prose max-w-none">
            <p className="text-sm text-gray-500 mb-8">Dernière mise à jour : 20 avril 2025</p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Éditeur du site</h2>
            <p className="text-gray-600 mb-4">
              Loustalet formation<br />
              Statut : EURL L'oustalet, Conseils et Formations<br />
              Adresse : 45 rue haute saint paterne, 36100 ISSOUDUN<br />
              N° SIRET : 893 608 976 00013 – N° TVA intracom. : FR13893608976 (non assujetti)<br />
              Téléphone : 06 76 44 03 65<br />
              E‑mail : <a href="mailto:loustaletformation@gmail.com" className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a>
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Direction de la publication</h2>
            <p className="text-gray-600 mb-4">
              Marion Souvielle- Formatrice, dirigeante.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Conception & développement</h2>
            <p className="text-gray-600 mb-4">
              Site conçu et développé par Ambre Thomas – Pacapp<br />
              Contact : <a href="mailto:ambre@pacapp.fr" className="text-rose-500 hover:text-rose-600">ambre@pacapp.fr</a>
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Hébergement</h2>
            <p className="text-gray-600 mb-4">
              Le site est hébergé par :<br />
              Heroku, Inc.<br />
              650 7th Street<br />
              San Francisco, CA 94103<br />
              États-Unis<br />
              Tél. : +1 (877) 563-4311 – <a href="https://www.heroku.com" target="_blank" rel="noopener noreferrer" className="text-rose-500 hover:text-rose-600">www.heroku.com</a>
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Activité commerciale</h2>
            <p className="text-gray-600 mb-4">
              Accès aux formations payant (modalités détaillées dans les <button onClick={() => navigate('/cgu')} className="text-rose-500 hover:text-rose-600">Conditions Générales de Vente</button>).<br />
              Formation professionnelle et accompagnement à la Validation des Acquis de l'Expérience (VAE) dans le domaine de la petite enfance. Nos services comprennent des modules de formation en ligne, des QCM d'entraînement, et des sessions de visioconférence individuelles ou en groupe.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Paiements & médiation</h2>
            <p className="text-gray-600 mb-4">
              Paiements sécurisés opérés par Stripe Payments Europe.<br />
              En cas de litige, vous pouvez recourir gratuitement au médiateur de la consommation :<br />
              La Société Médiation Professionnelle, <a href="https://www.mediateur-consommation-smp.fr" target="_blank" rel="noopener noreferrer" className="text-rose-500 hover:text-rose-600">www.mediateur-consommation-smp.fr</a>,
              Alteritae 5 rue Salvaing 12000 Rodez<br/>
              (Conformément à l'article L.616‑1 du Code de la consommation).
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Protection des données personnelles</h2>
            <p className="text-gray-600 mb-4">
              Le site ne collecte aucune donnée à caractère personnel hors des informations nécessaires à l'inscription et à la facturation, lesquelles sont traitées via les services externes suivants :
            </p>

            <table className="w-full mb-4 border-collapse">
              <thead>
                <tr className="border-b">
                  <th className="py-2 text-left">Finalité</th>
                  <th className="py-2 text-left">Service tiers</th>
                  <th className="py-2 text-left">Base légale</th>
                  <th className="py-2 text-left">Durée de conservation</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-2">Gestion des inscriptions</td>
                  <td className="py-2">Google Forms / Google Workspace</td>
                  <td className="py-2">Exécution d'un contrat (art. 6‑1‑b RGPD)</td>
                  <td className="py-2">3 ans après la fin de la formation</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2">Paiements</td>
                  <td className="py-2">Stripe</td>
                  <td className="py-2">Exécution d'un contrat / obligation légale</td>
                  <td className="py-2">10 ans (exigences comptables)</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2">Mesure d'audience</td>
                  <td className="py-2">Google Analytics</td>
                  <td className="py-2">Consentement (art. 6‑1‑a RGPD)</td>
                  <td className="py-2">13 mois</td>
                </tr>
              </tbody>
            </table>

            <p className="text-gray-600 mb-4">
              Aucun DPO n'a été désigné (structure &lt; 250 employés, traitements non sensibles).<br />
              Vous pouvez exercer vos droits (accès, rectification, suppression…) en écrivant à <a href="mailto:loustaletformation@gmail.com" className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a>.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Cookies</h2>
            <p className="text-gray-600 mb-4">
              Lors de votre première visite, un bandeau vous invite à accepter ou refuser :
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Cookies techniques indispensables au fonctionnement du site.</li>
              <li>Cookies de mesure d'audience Google Analytics (activés uniquement après consentement).</li>
              <li>Cookies nécessaires au traitement des paiements Stripe (exonérés de consentement, art. 82 I Loi Informatique & Libertés).</li>
            </ul>
            <p className="text-gray-600 mb-4">
              Vous pouvez à tout moment gérer vos préférences via le lien « Gestion des cookies » présent en bas de page.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Propriété intellectuelle</h2>
            <p className="text-gray-600 mb-4">
              L'ensemble des contenus (textes, vidéos, supports de cours, logo « L'oustalet formation ») sont la propriété exclusive de Loustalet formation ou de ses partenaires.<br />
              Toute reproduction, représentation, adaptation ou exploitation, partielle ou totale, sans autorisation écrite préalable est strictement interdite (art. L122‑4 et suivants du Code de la propriété intellectuelle).
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Accessibilité</h2>
            <p className="text-gray-600 mb-4">
              Le site loustaletformation.fr n'est pas soumis aux obligations du RGAA (référentiel général d'amélioration de l'accessibilité) au titre de l'article 47 de la loi n° 2005‑102, car il ne relève pas d'une personne morale de droit public ni d'un organisme délégataire d'une mission de service public.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">11. Avertissement sur les contenus multimédias</h2>
            <p className="text-gray-600 mb-4">
              Les images et vidéos utilisés sur ce site sont :
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>soit des créations originales Loustalet formation ;</li>
              <li>soit des médias libres de droits ou sous licence adéquate ;</li>
              <li>soit publiés avec l'autorisation expresse de leurs auteurs.</li>
            </ul>
            <p className="text-gray-600 mb-4">
              Toute demande de retrait ou d'attribution peut être adressée à <a href="mailto:loustaletformation@gmail.com" className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a>.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">12. Droit applicable & juridiction compétente</h2>
            <p className="text-gray-600 mb-4">
              Les présentes mentions sont régies par le droit français.<br />
              En cas de différend, compétence exclusive est attribuée aux tribunaux français du ressort du siège de l'éditeur, sauf disposition législative ou réglementaire contraire.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}